import React from "react";
import Catalogue from "../Catalogue";
import { Link, useParams } from "react-router-dom";
import axios from "axios";

const ProductCategories = () => {
  const [loading, setLoading] = React.useState(true);
  const [productCategory, setProductCategory] = React.useState({});
  const { category } = useParams();
  // The clicked category name from the URL is the source of truth for both the
  // heading and the product filter. getOne only enriches the page with a
  // description / title image; a 404 there must NOT blank the filter
  // (doing so used to make the page show ALL products).
  const categoryName = decodeURIComponent(category || "");

  const getProductCategory = async () => {
    setLoading(true);
    try {
      const response = await axios.get(
        `/api/productCategory/getOne/${category}`
      );

      setProductCategory(response.data.productCategory || {});
      setLoading(false);
    } catch (error) {
      console.log(error);
      // Lookup failed: keep going with the URL name so filtering still works.
      setProductCategory({});
      setLoading(false);
    }
  };

  React.useEffect(() => {
    getProductCategory();
  }, [category]);

  const titleText = (
    <div>
      <p>{productCategory.description}</p>
    </div>
  );

  return (
    <>
      {loading && <div>Loading...</div>}
      {!loading && (
        <div>
          <Catalogue
            key={categoryName}
            title={categoryName}
            titleText={titleText}
            titleImage={
              productCategory.image && productCategory.image.length > 0
                ? productCategory.image[0].url
                : ""
            }
            category={categoryName}
            productCollection={""}
          />
        </div>
      )}
    </>
  );
};

export default ProductCategories;
